(function () {
  // Measure header group height so the hero can fill exactly the remaining viewport.
  const headerGroup = document.getElementById('header-group');
  function setHeaderOffset() {
    if (!headerGroup) return;
    document.documentElement.style.setProperty('--bhola-hg', headerGroup.offsetHeight + 'px');
  }
  setHeaderOffset();
  window.addEventListener('resize', setHeaderOffset);
  if (headerGroup && 'ResizeObserver' in window) {
    new ResizeObserver(setHeaderOffset).observe(headerGroup);
  }

  const menuToggle = document.querySelector('[data-bhola-menu-toggle]');
  const mobileMenu = document.querySelector('[data-bhola-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
      document.documentElement.classList.toggle('bhola-menu-open', !isOpen);
    });
  }

  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('[data-bhola-mega-toggle]');
    const openItems = document.querySelectorAll('.bhola-nav__item.is-open');
    if (toggle) {
      const item = toggle.closest('.bhola-nav__item');
      const opening = !item.classList.contains('is-open');
      openItems.forEach((openItem) => {
        openItem.classList.remove('is-open');
        openItem.querySelector('[data-bhola-mega-toggle]')?.setAttribute('aria-expanded', 'false');
      });
      item.classList.toggle('is-open', opening);
      toggle.setAttribute('aria-expanded', String(opening));
      return;
    }
    openItems.forEach((item) => {
      item.classList.remove('is-open');
      item.querySelector('[data-bhola-mega-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  });

  const WISHLIST_KEY = 'bhola-wishlist';
  const readWishlist = () => {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }
    catch (error) { return []; }
  };
  const saveWishlist = (items) => localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
  const productKey = (item) => item.handle || item.url || item.title;

  function refreshWishlistButtons() {
    const items = readWishlist();
    const keys = new Set(items.map(productKey));
    document.querySelectorAll('[data-bhola-wishlist-button]').forEach((button) => {
      const key = button.dataset.handle || button.dataset.url || button.dataset.title;
      const active = keys.has(key);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-bhola-wishlist-button]');
    if (!button) return;
    event.preventDefault();
    const item = {
      handle: button.dataset.handle || '',
      title: button.dataset.title || 'Product',
      url: button.dataset.url || '#',
      image: button.dataset.image || '',
      price: button.dataset.price || ''
    };
    let items = readWishlist();
    const key = productKey(item);
    const existing = items.findIndex((saved) => productKey(saved) === key);
    if (existing >= 0) items.splice(existing, 1);
    else items.unshift(item);
    saveWishlist(items);
    refreshWishlistButtons();
    renderWishlistPage();
  });

  function renderWishlistPage() {
    const root = document.querySelector('[data-bhola-wishlist-root]');
    if (!root) return;
    const items = readWishlist();
    if (!items.length) {
      root.innerHTML = '<div class="bhola-wishlist-empty"><h2 class="bhola-serif">Your wishlist is empty</h2><p>Save products you love and return to them later.</p><a class="bhola-btn bhola-btn--primary" href="/collections/all">Start shopping</a></div>';
      return;
    }
    root.innerHTML = '<div class="bhola-products" style="--product-columns:4">' + items.map((item) => {
      const safeUrl = safeStorefrontUrl(item.url);
      const safeImage = safeStorefrontUrl(item.image, true);
      return `
      <article class="bhola-product-card">
        <div class="bhola-product-card__media">
          <a href="${safeUrl}">${safeImage ? `<img src="${safeImage}" alt="${escapeHtml(item.title)}" loading="lazy">` : ''}</a>
          <button class="bhola-wishlist is-active" type="button" data-bhola-wishlist-button data-handle="${escapeHtml(item.handle)}" data-title="${escapeHtml(item.title)}" data-url="${safeUrl}" data-image="${safeImage}" data-price="${escapeHtml(item.price)}" aria-label="Remove from wishlist" aria-pressed="true"><svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z"/></svg></button>
        </div>
        <div class="bhola-product-card__body"><h3 class="bhola-product-card__title"><a href="${safeUrl}">${escapeHtml(item.title)}</a></h3><div class="bhola-product-card__price">${escapeHtml(item.price)}</div></div>
      </article>`;
    }).join('') + '</div>';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, (character) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[character]));
  }

  function safeStorefrontUrl(value, allowCdn = false) {
    try {
      const url = new URL(String(value || ''), window.location.origin);
      const allowedHost = url.origin === window.location.origin || (allowCdn && (url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopifycdn.com')));
      return allowedHost && ['http:', 'https:'].includes(url.protocol) ? escapeHtml(url.href) : '#';
    } catch (error) {
      return '#';
    }
  }

  refreshWishlistButtons();
  renderWishlistPage();
  document.addEventListener('shopify:section:load', function () {
    refreshWishlistButtons();
    renderWishlistPage();
  });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-fancy-prev], [data-fancy-next]');
    if (!button) return;
    const section = button.closest('.bhola-fancy');
    const carousel = section?.querySelector('[data-fancy-carousel]');
    if (!carousel) return;
    const card = carousel.querySelector('.bhola-fancy-product');
    const distance = card ? card.getBoundingClientRect().width + 20 : carousel.clientWidth * 0.8;
    carousel.scrollBy({ left: button.hasAttribute('data-fancy-prev') ? -distance : distance, behavior: 'smooth' });
  });
})();
